import { NgModule } from '@angular/core';
import { DcsDateService } from './dcs-date.service';

@NgModule({
  providers: [DcsDateService],
  imports: [],
})
export class DcsDateServiceModule {}
